var React = require('react');
var lodash = require('lodash').noConflict();
var labels = require('MemberJoinLabels');
var memberTypeChecker = require('../../../../../Scripts/React/MemberTypeChecker.jsx').step2;
var { $input } = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/Validation/ValidationComponents.jsx');
var $credentialsSelect = require('./CredentialsSelect.jsx');

class Credentials extends React.Component {
    constructor(props) {
        super(props);
        this.bindFunctions();
    }

    bindFunctions() {
        this.getAvailableCredentials = this.getAvailableCredentials.bind(this);
        this.getCredentialsDropdown = this.getCredentialsDropdown.bind(this);
        this.getDeletableCredsMarkup = this.getDeletableCredsMarkup.bind(this);
        this.getSelectedCredsList = this.getSelectedCredsList.bind(this);
        this.handleCredentialsSelectBlur = this.handleCredentialsSelectBlur.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleMultiSelectChange = this.handleMultiSelectChange.bind(this);
    }

    componentDidMount() {
        this.props.loadApiData('credentials');

        // If user set credentials, but went back and changed to an app type with no credentials, clear them out
        if (memberTypeChecker.hideCredentials(this.props.appState.appType)) {
            this.props.updateStepState('credentials', []);
        } else {
            this.props.updateComponentMarkup('credentialsDropdown', this.getCredentialsDropdown());
        }
    }

    handleInputChange(event) {
        this.props.updateStepStateMultiSelect(event.target.name, event.target.value, event.target.checked);
    }

    handleMultiSelectChange(fieldName, credential, isChecked) {
        var value = credential.Code ? credential.Code : credential.value;
        this.props.updateStepStateMultiSelect(fieldName, value, isChecked);
    }

    // added window to credentials select, not sure if we need to scroll on blur anymore
    handleCredentialsSelectBlur() {
        var scrollTo = $('.credentials-container');
        var header = $('header');

        if (scrollTo && scrollTo.length && header) {
            $('html, body').animate({ scrollTop: scrollTo.offset().top - header.height() - 40 }, '50'); // account for header and padding
        }
    }

    getSelectedCredsList() {
        return this.props.stepState.credentials.map((selectedCred) => {
            var credData = this.props.appState.apiData.credentials.filter((apiCred) => {
                return apiCred.Code === selectedCred;
            });

            if (credData && credData.length) {
                return <span>{credData[0].Description}</span>;
            }
        });
    }

    getDeletableCredsMarkup() {
        return this.props.stepState.credentials.map((selectedCred) => {
            var credData = this.props.appState.apiData.credentials.filter((apiCred) => {
                return apiCred.Code === selectedCred;
            });

            if (credData && credData.length) {
                return <span key={credData[0].Code} onClick={() => this.handleMultiSelectChange("credentials", credData[0], false)}>{credData[0].Description}</span>;
            }
        });
    }

    getAvailableCredentials() {
        // get all the credentials where cred.Option6 contains current producttype or Option6 is empty string
        var unselectedCreds = this.props.appState.apiData.credentials.filter((cred) => {
            return this.props.stepState.credentials.filter((selectedCred) => {
                    return selectedCred === cred.Code;
                }).length === 0;
        });

        var appTypeHasCred = (cred) => {
            return cred.Option6.split(',').filter((credOption) => {
                return credOption.replace(' ', '') === this.props.appState.productType;
            }).length > 0;
        }

        return unselectedCreds.filter((cred) => {
            return cred.Option6 === '' ? true : appTypeHasCred(cred);
        });
    }

    getCredentialsDropdown() {
        return <$credentialsSelect checkUserExistingModal={this.props.checkUserExistingModal} fieldName="credentials" credentialsList={this.getAvailableCredentials()} initialValue={this.props.stepState.credentials} changeFunction={this.handleMultiSelectChange} />;
    }

    render() {
        if (memberTypeChecker.hideCredentials(this.props.appState.appType)) {
            return null;
        }

        var credsMarkup = this.getSelectedCredsList();
        var deletableCredsMarkup = this.getDeletableCredsMarkup();

        credsMarkup = lodash.flatMap(credsMarkup,
            (value, index, array) =>
            array.length - 1 !== index // check for last item
            ? [value, ", "]
            : value
        );

        deletableCredsMarkup = lodash.flatMap(deletableCredsMarkup,
            (value, index, array) =>
            array.length - 1 !== index // check for last item
            ? [value, ", "]
            : value
        );

        return <div className={"credentials-container"}>
            <div className={"row"}>
                <div className={"panel"}>
                    <div className={"col-md-12"}>
                        <h3>{labels.step2.credentials}</h3>
                    </div>
                    <div className={"edit"}>
                        <div className={"col-md-6"}>
                            <h4>{credsMarkup}</h4>
                            <hr className={"divider"} />
                            <h5 className={"creds-edit"}>{deletableCredsMarkup}</h5>
                            <div className={"credential-wrap"}>
                                {this.getCredentialsDropdown()}
                            </div>

                            <span onClick={() => { return this.props.showInfoModal('credentials') }}><span className={"get-info"}>{this.props.getInfoModalContent("credentials").infoIconLabel}</span></span>

                        </div>
                    </div>
                </div>
            </div>      
        </div>;
    }
}

module.exports = Credentials;